
import {
  Component, PropSync, Mixins, Ref, Prop,
} from 'vue-property-decorator';
import { periodItems, PeriodItemValueType } from '@/features/common/raw';
import focusMixin from '@/features/common/mixins/focusMixin';
import { getLastDateRangeFromToday } from '@/features/common/helpers/moment';
import { VForm } from '@/features/common/types';
import { downloadURI, showErrorAlertDialog } from '@/features/common/helpers';
import { exportShipmentHistory } from '../services/shipment-history.services';

@Component
export default class HistoryExportModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: false, default: true }) meOnly!: boolean;

  @Prop({ required: false, default: false }) deleted!: boolean;

  @Prop({ required: false, default: false }) carrierDirect!: boolean;

  @Prop({
    required: false,
    type: Object,
    default: () => ({ fromDate: '', toDate: '' }),
  }) dateRange!: { fromDate: string, toDate: string };

  @Ref('formHistoryExport') formHistoryExport!: VForm;

  private periodItems = [
    ...periodItems,
    {
      value: 'Custom',
      displayName: 'Custom Range',
    },
  ];

  private periodInput: PeriodItemValueType = 'Last7Days';

  private defaultDateRange = getLastDateRangeFromToday('Last7Days');

  private isLoading = false;

  private formData = {
    meOnly: this.meOnly,
    deleted: this.deleted,
    carrierDirect: this.carrierDirect,
    timePeriod: {
      fromDate: this.dateRange.fromDate || this.defaultDateRange.fromDate,
      toDate: this.dateRange.toDate || this.defaultDateRange.toDate,
    },
  }

  get existingDateRange(): string {
    const { fromDate, toDate } = this.dateRange;
    if (!toDate) return fromDate;
    return `${fromDate}&nbsp;&nbsp;-&nbsp;&nbsp;${toDate}`;
  }

  private async submitExport() {
    const isValid = this.formHistoryExport.validate();
    if (!isValid) return;

    this.isLoading = true;
    const exportedResponse = await exportShipmentHistory({
      myAccount: this.formData.carrierDirect,
      isDontShowSharedUsers: this.formData.meOnly,
      deleted: this.formData.deleted,
      dateRange: this.formData.timePeriod,
    });
    this.isLoading = false;

    if (!exportedResponse) {
      showErrorAlertDialog();
      return;
    }

    const blobCSVResponse = new Blob([exportedResponse], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blobCSVResponse);

    const { fromDate, toDate } = this.formData.timePeriod;
    downloadURI(url, `${fromDate}-to-${toDate}`);

    this.syncedShow = false;
  }

  private onChangePeriod(period: { fromDate: string, toDate: string}) {
    this.formData.timePeriod = period;
  }
}
